import { useGlobalData } from "../../context/GlobalDataContext";

const PermissionDenied = () => {
    const { globalData } = useGlobalData();

    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-12 text-center">
                    <div className="home-wrapper">
                        <div className="mb-4">
                            <a href="/" className="d-block auth-logo">
                                <img
                                     src={`${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData?.COMPANY_LOGO}`}
                                    alt="Logo"
                                    height={50}
                                    className="auth-logo-dark mx-auto"
                                />
                                <img
                                     src={`${process.env.REACT_APP_BASE_URL}/v1/globalSettings/${globalData?.COMPANY_LOGO}`}
                                    alt="Logo"
                                    height={50}
                                    className="auth-logo-light mx-auto"
                                />
                            </a>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-sm-4">
                                <div className="maintenance-img">
                                    <img
                                        src="/assets/images/icons8-access-denied-40.png" 
                                        alt="Access Denied"
                                        className="img-fluid mx-auto d-block"
                                    />
                                </div>
                            </div>
                        </div>
                        <h3 className="mt-5 text-danger">Access Denied</h3>
                        <p className="text-muted">
                            You don’t have permission to view this page. <br />
                            Please contact your administrator for access.
                        </p>
                        <a href="/" className=" text-primary">
                            Back to Home
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PermissionDenied;
